import { SvgIcon } from '@mui/material';

export default function AdminIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.8358 7.18192C11.264 5.51831 12.7742 4.28906 14.5714 4.28906C16.3687 4.28906 17.8789 5.51831 18.3071 7.18192L20.0357 7.18192C20.5683 7.18192 21 7.61365 21 8.14621C21 8.67877 20.5683 9.11049 20.0357 9.11049L18.3071 9.11049C17.8789 10.7741 16.3687 12.0033 14.5714 12.0033C12.7742 12.0033 11.264 10.7741 10.8358 9.11049L3.96429 9.11049C3.43173 9.11049 3 8.67877 3 8.1462C3 7.61364 3.43172 7.18192 3.96429 7.18192L10.8358 7.18192ZM12.6429 8.1462C12.6429 7.08108 13.5063 6.21763 14.5714 6.21763C15.6365 6.21763 16.5 7.08108 16.5 8.1462C16.5 9.21133 15.6365 10.0748 14.5714 10.0748C13.5063 10.0748 12.6429 9.21133 12.6429 8.1462Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.42857 19.7176C11.2258 19.7176 12.736 18.4884 13.1642 16.8248H20.0357C20.5683 16.8248 21 16.3931 21 15.8605C21 15.3279 20.5683 14.8962 20.0357 14.8962H13.1642C12.736 13.2326 11.2258 12.0033 9.42857 12.0033C7.6313 12.0033 6.12113 13.2326 5.69295 14.8962H3.96429C3.43173 14.8962 3 15.3279 3 15.8605C3 16.3931 3.43173 16.8248 3.96429 16.8248H5.69295C6.12113 18.4884 7.6313 19.7176 9.42857 19.7176ZM11.3571 15.8605C11.3571 16.9256 10.4937 17.7891 9.42857 17.7891C8.36345 17.7891 7.5 16.9256 7.5 15.8605C7.5 14.7954 8.36345 13.9319 9.42857 13.9319C10.4937 13.9319 11.3571 14.7954 11.3571 15.8605Z'
          fill='currentColor'
        />
      </svg>
    </SvgIcon>
  );
}
